import { config } from '@/config';

export const getProspectiveUrl = (
  publishedSlug?: string,
  slug?: string
): string => {
  return `${config.server.url}/page/${slug ?? publishedSlug}`;
};

export const isValidSlug = (slug: string) => {
  return /^[a-z0-9]+([a-z0-9-]*[a-z0-9-])?$/.test(slug);
};
